import axiosClient from "@/lib/axiosClient"
import type { AppConfig } from "@/types"
import { useQuery } from "@tanstack/react-query"

export interface CurrentUser {
  id: string
  username: string
  role: number
  profile_image: string | null
  show_bw_suggestions: boolean
  show_alerts: boolean
  notifications?: unknown[]
  apps: AppConfig[]
  org?: {
    id: string
    name: string
    support_chat_link?: string | null
    apps?: AppConfig[]
  } | null
}

export const fetchCurrentUser = async (): Promise<CurrentUser> => {
  const res = await axiosClient.get<CurrentUser>("/auth/user/me")
  return res.data
}

export const useCurrentUser = () => {
  const token = localStorage.getItem("access_token")

  return useQuery({
    queryKey: ["auth", "me", token],
    queryFn: fetchCurrentUser,
    enabled: Boolean(token),
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
  })
}
